import { Box, Chip, Grid, Paper} from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getVendorWalletTransactions } from "services/vendorDashboard";
import '@inovua/reactdatagrid-community/index.css'
import ReactDataGrid from "@inovua/reactdatagrid-community";

export default function WeSecureWallet({vendorId}) {
  
  const [, setGridRef] = useState(null);
  
  const { enqueueSnackbar } = useSnackbar();
  const [transactions, setTransactions] = useState([]);
  const gridStyle = useMemo(() => ({ height:( transactions.length > 0 ? transactions.length * 56.2 :  500), width: 'auto', maxHeight: '70vh'}), [transactions]);

  const columns = useMemo(() => ([
    { name: 'type', header: 'Type', sortable: false, defaultFlex: 1, minWidth: 120,},
    { name: 'createdOn', header: 'Date', sortable: false,defaultFlex: 1, minWidth: 100,},
    { name: 'description', header: 'Description', minWidth: 300, sortable: false, defaultFlex: 1,},
    { name: 'openingBalance', header: 'Opening Balance',minWidth: 200, sortable: false, defaultFlex: 1,},
    { name: 'amount', header: 'Amount', sortable: false, defaultFlex: 1, minWidth: 120,render: ({data}) => {
      return <Chip label={`${data?.type === 'credit' ? '+' : '-'}${data.amount}`} color={data?.type === 'credit' ? 'success' : 'error'} size="small" />
    }},
    { name: 'closingBalance', header: 'Closing Balance', sortable: false, defaultFlex: 1, minWidth: 160,},
  ]), []);

  const getWalletTransactions = useCallback((vendorId) => {
    getVendorWalletTransactions({},{},{vendorId}).then(({response, error}) => {
      if(response){
        setTransactions(response);
      } else {
        setTransactions([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(vendorId){
      getWalletTransactions(vendorId);
    }
  }, [getWalletTransactions, vendorId]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate >
        <Grid container columnSpacing={4} rowSpacing={2} >
          <Grid item xs={12} sm={12} md={12} lg={12} >
              <Box component="div" sx={{  maxHeight: 720, width: '100%' }}>
                <ReactDataGrid
                  handle={setGridRef}
                  idProperty="transactionId"
                  style={gridStyle}
                  // defaultFilterValue={defaultFilterValue}
                  columns={columns}
                  dataSource={transactions}
                  rowHeight={null} 
                  minRowHeight={50}
                  showColumnMenuTool={false} 
                />
              </Box>
            </Grid>
          
          {/* {transactions?.length === 0 ? (
            <Typography color="error" variant="h5" component="h5"> No data found</Typography>
          ): null} */}
        </Grid>
      </Box>
    </Paper>
  );
}
